import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';
import i18next from 'i18next';

import '../DataGrid.scss';

class TextFilter extends Component {

    render() {
        const { filter, onChange, ...rest } = this.props;

        return (
            <div>
                <input
                    type="text"
                    onChange={event => onChange({ content: event.target.value })}
                    placeholder={i18next.t('search')}
                    value={filter ? filter.value.content : ''}
                    className='pi-data-grid-filter-component pi-data-grid-filter-input'
                />
                {
                    filter && filter.value.content ?
                        <button className='pi-data-grid-filter-clear' onClick={() => onChange({ content: '' })}>
                            <Icon name="close" color="grey" />
                        </button>
                        : null
                }
            </div>
        );

    }
}

TextFilter.propTypes = {
    filter: PropTypes.object,
    onChange: PropTypes.func.isRequired,
};

export default TextFilter;